import JwtService from "@/services/JwtService";

// actions
export const VERIFY_AUTH = 'verifyAuth';

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";

export const UPDATE_USER = 'updateUser'
export const SET_ERROR = "setError";
const token = JwtService.getToken();

const state = {
    user: token !== null ? token.user : {},
    isAuthenticated: token !== null
};

const getters = {
    currentUser(state) {
        return state.user;
    },
    isAuthenticated(state) {
        return state.isAuthenticated;
    }
};

const actions = {
    [VERIFY_AUTH]() {
        return new Promise(resolve => {
            const token = JwtService.getToken();
            resolve(token !== null && token.accepted);
        });
    }
}

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_AUTH](state, data) {
        state.isAuthenticated = true;
        state.user = data.user;
        JwtService.saveToken(data);
    },
    [UPDATE_USER](state, user) {
        const token = JwtService.getToken();
        if (token !== null) {
            state.user = user;
            token.user = user;
            JwtService.saveToken(token);
        }
    },
    [PURGE_AUTH](state) {
        state.isAuthenticated = false;
        state.user = {};
        JwtService.destroyToken();
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
